<template>
  <iq-card>
    <template v-slot:headerTitle>
      <div class="d-flex align-items-center text-primary cursor-pointer">
        <i
          class="fa fa-arrow-left"
          @click="$router.push('/maintenance/main-job-libraries')"
        ></i>
        <h4 class="card-title text-primary ml-3">
          <strong>Job Library - {{ $route.query.component_name }}</strong>
        </h4>
      </div>
    </template>

    <template v-slot:body>
      <JobLibraries />
    </template>
  </iq-card>
</template>

<script>
import JobLibraries from './JobLibraries.vue'

export default {
  name: 'JobLibraryPerCategory',
  components: {
    JobLibraries,
  },
}
</script>
